import React, { useContext } from 'react';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import HowToVoteRoundedIcon from '@mui/icons-material/HowToVoteRounded';
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Collapse } from '@mui/material';
import { Stack } from '@mui/system';
import { getRuta, isAccess } from '../../helpers/Helpers';
import { DataContext } from '../../context/DataContext';
import NavItem from './NavItem';
import { sidebar } from '../../theme';

const Administracion = ({ drawerIsOpen }) => {
	const [open, setOpen] = React.useState(false);
	let rout = getRuta();
	const { access } = useContext(DataContext);
	return (
		<div>
			<Box
				onClick={() => setOpen(!open)}
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '12px',
					padding: '10px 14px',
					borderRadius: '9px',
					cursor: 'pointer',
					color: sidebar.itemColor,
					marginBottom: '2px',
					'&:hover': { backgroundColor: 'rgba(255,255,255,.06)', color: '#e8edf3' }
				}}
			>
				<Box sx={{ display: 'flex', color: sidebar.iconColor, fontSize: 20 }}>
					<BusinessCenterRoundedIcon fontSize="inherit" />
				</Box>
				<Box component="span" sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
					Administración
				</Box>
				{open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
			</Box>

			<Collapse in={open} timeout="auto" unmountOnExit>
				<Stack paddingLeft={drawerIsOpen ? 1.5 : 0} spacing={0.2}>
					{isAccess(access, 'ACAJA VER') ? (
						<>
							<NavItem sub to={`${rout}/cashregister`} icon={<HowToVoteRoundedIcon fontSize="inherit" />} label="Arqueo General" />
							<NavItem sub to={`${rout}/arqueouser`} icon={<SavingsRoundedIcon fontSize="inherit" />} label="Arqueo Usuario" />
						</>
					) : null}
				</Stack>
			</Collapse>
		</div>
	);
};

export default Administracion;
